import { playerEventsConstants } from 'src/components/player/src/constants/playerConstants';
import { widgetCTAEvent } from 'src/utils/analytics/mixpanel/mixpanelEventsHelper';
import { generateCardsUrl } from 'src/utils/cardsUrlGenerator';
import { DynamicObject } from 'src/utils/commonTypes';
import {
  ZEE_PLAYER_MAPPING,
  ZEE_SELF_ERROR
} from 'src/utils/constants/ApiConstants';
import { getPlatformName } from 'src/utils/UtilityMethods';
import { globalUrlHelper } from 'src/utils/VideoPlayerUtils/Utils';

import {
  IfetchNextVideos,
  IfetchPreviousVideos,
  IplayNext,
  IToggleTrailerButton,
  IWatchHistory,
  IUpdateMandatoryRegistrationViewCount,
  IEligibleMandatoryRegistrationViewCount
} from './PlayerInterface/PlayerCallbackInterface';
import {
  getLocalStorage,
  getCookie,
  setLocalStorage
} from '../../../utils/browserStorageHandler';
import { XACCESS_AUTHORIZATION_COOKIE } from '../../../utils/constants/cookieConstants';
import {
  SKIP_CONTENT_LANGUAGES_POPUP,
  SUBSCRIBE_FROM_PLAYER,
  SUBSCRIPTION_PREVIOUS_ROUTE,
  USER_TOKEN,
  MANDATORY_REGISTRATION_POPUP_COUNT,
  MANDATORY_REGISTRATION_VIDEO_COUNT
} from '../../../utils/constants/localStorageConstants';
import { MANDATORY_REGISTRATION_POPUP_CONFIG } from '../../../utils/constants/stringConstants';
import { getWatchHistoryUrl } from '../../../utils/UrlGenerator';

const eligibleMandatoryRegistrationContent = ({
  contentData,
  updateViewedCount = false,
  country
}: IEligibleMandatoryRegistrationViewCount) => {
  const eligibleContent =
    country === 'IN' &&
    contentData &&
    contentData.content_qualify_for_mandatory_reg;
  const currentVideoCount =
    Number(getLocalStorage(MANDATORY_REGISTRATION_VIDEO_COUNT)) || 0;
  if (eligibleContent && updateViewedCount) {
    setLocalStorage(MANDATORY_REGISTRATION_VIDEO_COUNT, currentVideoCount + 1);
  }
  if (
    eligibleContent &&
    updateViewedCount &&
    currentVideoCount >= MANDATORY_REGISTRATION_POPUP_CONFIG
  ) {
    const currentPopupCount =
      Number(getLocalStorage(MANDATORY_REGISTRATION_POPUP_COUNT)) || 0;
    setLocalStorage(MANDATORY_REGISTRATION_POPUP_COUNT, currentPopupCount + 1);
  }
  const showMandatoryPopUp =
    eligibleContent && currentVideoCount >= MANDATORY_REGISTRATION_POPUP_CONFIG;
  return showMandatoryPopUp;
};

export function updateMandatoryRegistrationViewCount({
  countryList,
  contentData,
  country
}: IUpdateMandatoryRegistrationViewCount) {
  eligibleMandatoryRegistrationContent({
    contentData,
    updateViewedCount: true,
    country
  });
}

export function gotoLogin() {
  setLocalStorage(SKIP_CONTENT_LANGUAGES_POPUP, true);
  window.location.href = '/signin?redirectFromWebApp=1';
  // window.location.replace('/signin?redirectFromWebApp=1');
}

export function gotoRegister() {
  window.location.href = '/register?redirectFromWebApp=1';
  // window.location.replace('/register?redirectFromWebApp=1');
}

/* Clear the timer of PopUp Nudge */
export const clearSubscriptionNudgePopupTimer = () => {
  if (typeof window !== 'undefined' && window.avodNudgeHandler) {
    clearTimeout(window.avodNudgeHandler);
    window.avodNudgeHandler = null;
  }
};

export function goToSubscription({ country, router, tvodObj }: DynamicObject) {
  setLocalStorage(SKIP_CONTENT_LANGUAGES_POPUP, true);
  setLocalStorage(SUBSCRIPTION_PREVIOUS_ROUTE, window.location.pathname);
  const globalPath = window.location.pathname.replace('/global', '');
  const path = country === 'IN' ? window.location.pathname : globalPath;
  setLocalStorage(SUBSCRIBE_FROM_PLAYER, path);
  if (tvodObj && tvodObj.isComboOfferEnabled) {
    // pushRoute({
    //   pathname: getLocalStorage(OFFER_PATH),
    //   state: window.location.pathname
    // });
  } else {
    window.location.href = globalUrlHelper('/myaccount/subscription');
  }
}

export function playNext({ newContentObject }: IplayNext) {
  setLocalStorage(SKIP_CONTENT_LANGUAGES_POPUP, true);
  navigationHandler(newContentObject);
  // if (
  //   indexObject &&
  //   indexObject.assetSubtype &&
  //   indexObject.assetSubtype.toLowerCase() === 'reco' &&
  //   indexObject.talamoosModelName
  // ) {
  //   recommendedCardClickAction({
  //     modelName: indexObject.talamoosModelName,
  //     itemID: newContentObject.id,
  //     clickID: indexObject.clickID,
  //     region,
  //     country
  //   });
  // }
}
// /* Blocker popup callbacks - END */

export function watchHistoryApi({
  watchMethod,
  bodyParams,
  userType,
  guestToken
}: IWatchHistory) {
  let userParams = {};
  const USERAPI = process.env.NEXT_PUBLIC_WATCH_HISTORY_BASE_ADDRESS
    ? process.env.NEXT_PUBLIC_WATCH_HISTORY_BASE_ADDRESS
    : '';
  const watchURLApiZee5 = getWatchHistoryUrl(USERAPI);

  if (userType === 'guest') {
    userParams = {
      'X-Z5-Guest-Token': guestToken,
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Z5-AppPlatform': getPlatformName()
    };
  } else {
    userParams = {
      Authorization: localStorage.getItem('ID'),
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Z5-AppPlatform': getPlatformName()
    };
  }

  fetch(watchURLApiZee5, {
    method: watchMethod,
    headers: userParams,
    body: JSON.stringify(bodyParams)
  })
    .then((response) => {
      if (response.ok) {
        response
          .json()
          .then((data) => {
            return data;
          })
          .catch((error) => {
            console.error('Error while fetching content details: ', error);
          });
      }
    })
    .catch((error) =>
      console.log('Error while fetching content details: ', error)
    );
}

// // Returns special price dynamic translation ( strip below player price)
// export function getSpecialPriceText(priceText) {
//   // Dynamically setting plan price for teaser banner from subscription api
//   const {
//     duration_text: originalPrice = 0,
//     price = 0,
//     currency = '₹',
//     billing_frequency = 0
//   } = window.specialPlan || {};
//   const specialPriceMessage =
//     priceText &&
//     priceText
//       .replace('{{price}}', price)
//       .replace(
//         '{{discount_value_computed}}',
//         Math.floor(((originalPrice - price) * 100) / originalPrice)
//       )
//       .replace('{{currency}}', currency)
//       .replace(
//         '{{duration}}',
//         getDaysInYearOrMonthInEnglish({
//           days: billing_frequency,
//           skipLiteralOne: true
//         })
//       )
//       .replace('INR', '₹');
//   return specialPriceMessage;
// }

// // Api to get next recommended videos
export async function fetchNextVideos({
  displayLanguage,
  country,
  contentId,
  contentLanguage,
  userType
}: IfetchNextVideos) {
  const url = new URL(
    `${process.env.NEXT_PUBLIC_GWAPI}/content/player/${contentId}`
  );

  let xAccessToken;
  if (getCookie(XACCESS_AUTHORIZATION_COOKIE)) {
    xAccessToken = getCookie(XACCESS_AUTHORIZATION_COOKIE);
  } else {
    // xAccessToken = platFormTokenGenerator(); TODO: implement platformToken
    // alert('xAccessToken')
    // TODO: when xAccessToken not present
    xAccessToken = getLocalStorage(USER_TOKEN);
  }
  const headers: DynamicObject = { 'X-Access-Token': xAccessToken };
  // const headers = [ HTTP_HEADER_KEYS.X_ACCESS_TOKEN]
  const params = {
    user_type: userType || 'guest',
    limit: 25,
    translation: displayLanguage,
    country,
    languages: contentLanguage
  };
  Object.keys(params).forEach((key) =>
    url.searchParams.append(key, (params as any)[key])
  );
  let recoData = [];
  // TODO :: Replace with http service
  recoData = await fetch(url, { headers })
    .then((response) => {
      return response.json();
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error('Error while fetching reco content details: ', error);
    });
  return recoData;
}

// // Api to get previous recommended videos
export async function fetchPreviousVideos({
  displayLanguage,
  country,
  playerRef
}: IfetchPreviousVideos) {
  const { playableData = {}, singlePlayDetails = {} } = playerRef || {};
  const { showDetails = {}, assetDetails = {} } = singlePlayDetails;
  const showDetail = showDetails || (assetDetails && assetDetails.show_details);
  const contentAssetType = showDetail && showDetail.asset_subtype;
  const currentSeasonId = playableData && playableData.season;
  const currentEpisodeId = playableData && playableData.id;
  const allSeasons = showDetail && showDetail.seasons;
  const currentSeasonData =
    allSeasons &&
    currentSeasonId &&
    allSeasons[allSeasons.findIndex((e: any) => e.id === currentSeasonId)];
  const isFinalSeason =
    allSeasons &&
    currentSeasonId &&
    allSeasons.findIndex((e: any) => e.id === currentSeasonId) === 0;
  const isFinalEpisode =
    currentSeasonData &&
    currentSeasonData.episodes &&
    currentEpisodeId &&
    currentSeasonData.episodes.findIndex(
      (e: any) => e.id === currentEpisodeId
    ) ===
      currentSeasonData.episodes.length - 1;

  let recoData;
  if (
    contentAssetType !== 'original' ||
    (contentAssetType === 'original' && !isFinalEpisode)
  ) {
    const url = new URL(
      `${process.env.NEXT_PUBLIC_GWAPI}/content/season/next_previous/${playableData.season}`
    );
    let xAccessToken;
    if (getCookie(XACCESS_AUTHORIZATION_COOKIE)) {
      xAccessToken = getCookie(XACCESS_AUTHORIZATION_COOKIE);
    } else {
      // TODO
      // xAccessToken = platFormTokenGenerator();
    }
    const headers: DynamicObject = { 'X-Access-Token': xAccessToken };
    // const headers = [ HTTP_HEADER_KEYS.X_ACCESS_TOKEN]
    const params = {
      episode_id: playableData.id,
      type: 'next',
      limit: 25,
      translation: displayLanguage,
      country,
      page: 1
    };
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, (params as any)[key])
    );
    recoData = await fetch(url, { headers })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        return response;
      });
  } else if (
    contentAssetType === 'original' &&
    isFinalEpisode &&
    !isFinalSeason
  ) {
    const currentSeasonIndex = allSeasons.findIndex(
      (e: any) => e.id === currentSeasonId
    );
    const nextSeasonData = allSeasons[currentSeasonIndex - 1];
    recoData = { items: nextSeasonData.episodes };
  } else if (
    contentAssetType === 'original' &&
    isFinalEpisode &&
    isFinalSeason
  ) {
    const nextSeasonData = allSeasons[allSeasons.length - 1];
    recoData = { items: nextSeasonData.episodes };
  }
  return recoData;
}

export function toggleWatchTrailerButton({ disable }: IToggleTrailerButton) {
  const watchTrailerBtn = document.querySelector('.promoButtonDiv');
  if (
    disable &&
    watchTrailerBtn &&
    watchTrailerBtn.className.indexOf('trailerPlayback') === -1
  ) {
    watchTrailerBtn.classList.add('trailerPlayback');
  } else if (
    watchTrailerBtn &&
    watchTrailerBtn.className.indexOf('trailerPlayback') >= 0
  ) {
    watchTrailerBtn.classList.remove('trailerPlayback');
  }
}

export function createEduauraaMessage() {
  const { messages = {} } = window.translationsAndConfigs || {};
  const eduauraaMessage = document.createElement('DIV');
  eduauraaMessage.className = 'eduauraaMessage';
  if (messages && Object.keys(messages).length) {
    eduauraaMessage.innerHTML = messages.learning_misc_demovid_text;
  }
  const eduauraa = document.querySelector('.eduauraaMessage');
  if (!eduauraa) {
    let videoContainer;
    if (
      document.querySelector('.playerContainer')?.children?.[0]?.tagName ===
      'DIV'
    ) {
      videoContainer = document.querySelector('#video-tag') as HTMLElement;
    } else {
      videoContainer = document.querySelector(
        '.playerContainer'
      ) as HTMLElement;
    }
    videoContainer.appendChild(eduauraaMessage);
  }
}

export function removeEduauraaMessage() {
  const eduauraa = document.querySelector('.eduauraaMessage');
  if (eduauraa) {
    let videoContainer;
    if (
      document.querySelector('.playerContainer')?.children?.[0]?.tagName ===
      'DIV'
    ) {
      videoContainer = document.querySelector('#video-tag') as HTMLElement;
    } else {
      videoContainer = document.querySelector(
        '.playerContainer'
      ) as HTMLElement;
    }
    videoContainer.removeChild(eduauraa);
  }
}

// const redirectFromPlayer = (item: DynamicObject) => {
//   navigationHandler(slugData, () => {
//     router.push(`/[...slug]`, `/${slugData}`, { shallow: true });
//   });
// };

export async function getSelfError() {
  if (!getLocalStorage('selfErrors')) {
    const selfErrorJson = await (await fetch(ZEE_SELF_ERROR)).json();
    setLocalStorage('selfErrors', selfErrorJson);
  }
  if (!getLocalStorage('errorMapping')) {
    const errorMappingJson = await (await fetch(ZEE_PLAYER_MAPPING)).json();
    setLocalStorage('errorMapping', errorMappingJson);
  }
}
const navigationHandler = (item: DynamicObject) => {
  const isPartner = window.location.pathname.includes('b2b-consumption');
  if (isPartner) {
    window.location.pathname = `/b2b-consumption/${item?.id}`;
  } else {
    let slugData = generateCardsUrl(item);
    slugData = slugData?.startsWith('/') ? slugData : `/${slugData}`;
    window.location.pathname = slugData;
  }
};
/* eslint-disable cyclomatic-complexity/zee-codeBlockComplexity */
export function createScoreContainer(payload: {
  teamA: string;
  scoreA: string;
  oversA: string;
  teamB: string;
  scoreB: string;
  oversB: string;
  matchId: string;
  tournamentId: string;
  title: string;
  currentAPIcheck: boolean;
}) {
  if (
    typeof window !== 'undefined' &&
    !window.location.pathname.includes('sports/cricket/ilt20/live-streaming') &&
    !window.location.pathname.includes('live-tv') &&
    payload?.currentAPIcheck
  ) {
    const container = document.querySelector('.scoreMainContainer');
    if (!container) {
      const scoreMainContainer = document.createElement('DIV');
      scoreMainContainer.className = 'scoreMainContainer';
      const scoreContainer = document.createElement('div');
      scoreContainer.className = 'scoreContainer';
      const teamContainer = document.createElement('div');
      teamContainer.className = 'teamContainer';
      const teamContainerB = document.createElement('div');
      teamContainerB.className = 'teamContainer';

      const teamContent = document.createElement('div');
      teamContent.className = 'teamContent';
      teamContent.textContent = payload.teamA;
      teamContainer.appendChild(teamContent);

      const pinContainer = document.createElement('img');
      pinContainer.className = 'pinContainer';
      pinContainer.src = `/webapp-assets/images/Unpin.svg`;

      const scorecard = document.createElement('div');
      scorecard.className = 'scorecardForSticky';

      const scorecardB = document.createElement('div');
      scorecardB.className = 'scorecardForSticky';

      const content = document.createElement('div');
      content.className = 'content';
      content.id = 'scoreContent';
      content.textContent = `${payload.scoreA} (${payload.oversA})`;
      scorecard.appendChild(content);

      // eslint-disable-next-line no-extra-boolean-cast
      if (!!payload.teamB) {
        const versus = document.createElement('div');
        versus.className = 'content';
        versus.id = 'versus';
        versus.textContent = 'vs';
        scorecard.appendChild(versus);

        const teamBContent = document.createElement('div');
        teamBContent.className = 'teamContentB';
        teamBContent.textContent = payload.teamB;
        teamContainerB.appendChild(teamBContent);
      }

      if (!!payload.teamB && !!payload.scoreB && !!payload.oversB) {
        const contentB = document.createElement('div');
        contentB.className = 'content';
        contentB.id = 'scoreContentB';
        contentB.textContent = `${payload.scoreB} (${payload.oversB})`;
        scorecardB.appendChild(contentB);
        if (!Number(payload.oversB)) {
          contentB.style.display = 'none';
        }
      }

      const liveDot = document.createElement('div');
      liveDot.className = 'liveDot';
      pinContainer.addEventListener('click', () => {
        scoreContainer.style.display =
          scoreContainer.style.display === 'none' ||
          scoreContainer.style.display === ''
            ? 'flex'
            : 'none';
        if (
          scoreContainer.style.display === 'none' ||
          scoreContainer.style.display === ''
        ) {
          pinContainer.src = `/webapp-assets/images/Pin.svg`;
          scoreMainContainer.style.display = 'none';
        } else {
          pinContainer.src = `/webapp-assets/images/Unpin.svg`;
          scoreMainContainer.style.display = 'flex';
        }
        if (pinContainer.src.includes('Unpin.svg')) {
          window.analyticsManager.reportEvent(playerEventsConstants.PIN, null);
        } else {
          window.analyticsManager.reportEvent(
            playerEventsConstants.UNPIN,
            null
          );
        }
        widgetCTAEvent(false, true);
      });
      scoreContainer.addEventListener('click', () => {
        window.analyticsManager.reportEvent(
          playerEventsConstants.SCORE_CLICK,
          null
        );
        if (
          payload.tournamentId !== 'undefined' &&
          payload.title !== 'undefined' &&
          payload.matchId !== 'undefined' &&
          payload.tournamentId &&
          payload.matchId
        ) {
          window.location.href = `/sports/cricket/ilt20/live-streaming/${payload.tournamentId}/${payload.title}/${payload.matchId}`;
        }
      });

      scoreContainer.appendChild(liveDot);
      scoreContainer.appendChild(teamContainer);
      scoreContainer.appendChild(scorecard);
      // eslint-disable-next-line no-extra-boolean-cast
      if (!!payload.teamB) {
        scoreContainer.appendChild(teamContainerB);
      }
      if (!!payload.teamB && !!payload.scoreB && !!payload.oversB) {
        scoreContainer.appendChild(scorecardB);
      }

      scoreMainContainer.appendChild(scoreContainer);
      scoreMainContainer.appendChild(pinContainer);

      const videoContainer = document.querySelector('.playerComp');
      const scoreBoard = document.querySelector('.scoreMainContainer');
      if (videoContainer && !scoreBoard) {
        videoContainer.appendChild(scoreMainContainer);
      }
    } else {
      const teamContent = document.querySelector('.teamContent');
      if (teamContent) {
        teamContent.textContent = payload.teamA;
      }

      const content = document.querySelector('#scoreContent');
      if (content) {
        content.textContent = `${payload.scoreA} (${payload.oversA})`;
      }
      // eslint-disable-next-line no-extra-boolean-cast
      if (!!payload.teamB) {
        const versus = document.querySelector('#versus');
        if (versus) {
          versus.textContent = 'vs';
        }

        const teamContentB = document.querySelector('.teamContentB');
        if (teamContentB) {
          teamContentB.textContent = payload.teamB;
        }
      }
      if (!!payload.teamB && !!payload.scoreB && !!payload.oversB) {
        const contentB = document.querySelector('#scoreContentB');
        if (contentB) {
          contentB.textContent = `${payload.scoreB} (${payload.oversB})`;
        }
      }
    }
  }
}

export function removeScorecardWidget() {
  const container = document.querySelector('.scoreMainContainer');
  if (container) {
    container.remove();
  }
}
